import { GoalProgressModel } from './progress';

enum Gender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  NON_BINARY = 'NON_BINARY',
  DONT_WANT_TO_DISCLOSE = 'DONT_WANT_TO_DISCLOSE'
}

enum Unit {
  BPM = 'BPM', // beats per minute
  CELSIUS = 'CELSIUS',
  HR_ZONE = 'HR_ZONE',
  KCAL = 'KCAL',
  KILOMETER = 'KILOMETER',
  KILOMETER_PER_HOUR = 'KILOMETER_PER_HOUR',
  METER = 'METER',
  METER_PER_SECOND = 'METER_PER_SECOND',
  MILE = 'MILE',
  MIN_PER_KM = 'MIN_PER_KM',
  PERCENT = 'PERCENT',
  REPS = 'REPS',
  RPM = 'RPM', // revolutions per minute
  SECOND = 'SECOND',
  SPM = 'SPM', // steps per minute
  TIMES = 'TIMES',
  WATT = 'WATT',
  WATT_ZONE = 'WATT_ZONE',
  YARD = 'YARD'
}

const UnitNamesIndex = {
  [Unit.BPM]: (v) => 'units.bpm.short',
  [Unit.CELSIUS]: (v) => 'units.celsius.short',
  [Unit.HR_ZONE]: (v) => 'units.hrZone.short',
  [Unit.KCAL]: (v) => 'units.kcal.short',
  [Unit.KILOMETER]: (v) => 'units.kilometer.short',
  [Unit.KILOMETER_PER_HOUR]: (v) => 'units.kilometerPerHour.short',
  [Unit.METER]: (v) => 'units.meter.short',
  [Unit.METER_PER_SECOND]: (v) => 'units.meterPerSecond.short',
  [Unit.MILE]: (v) => 'units.mile.short',
  [Unit.MIN_PER_KM]: (v) => 'units.minPerKm.short',
  [Unit.PERCENT]: (v) => 'units.percent.short',
  [Unit.RPM]: (v) => 'units.rpm.short',
  [Unit.SECOND]: (v) => 'units.second.short',
  [Unit.SPM]: (v) => 'units.spm.short',
  [Unit.WATT]: (v) => 'units.watt.short',
  [Unit.YARD]: (v) => 'units.yard.short',
  [Unit.REPS]: (v) => 'units.repetitions.short',
  [Unit.WATT_ZONE]: (v) => 'units.wattZone.short',
  [Unit.TIMES]: (v) => (v === 1 ? 'units.times.single' : 'units.times.plural')
};

interface SuccessCreatedEntity {
  entityId: string;
  success: boolean;
}

enum GoalSubscriptionPriority {
  HIGH = 'HIGH',
  MEDIUM = 'MEDIUM',
  LOW = 'LOW'
}

enum GoalSubscriptionStatus {
  ACQUIRED = 'ACQUIRED', // This is a special status for goals that are not yet subscribed but can be enrolled
  ACCESS_GRANTED = 'ACCESS_GRANTED', // UI-only: the API never sends it; it marks a mentor's pending grant
  PENDING_ACTIVE = 'PENDING_ACTIVE',
  ACTIVE = 'ACTIVE',
  PAUSED = 'PAUSED',
  PENDING_DELETED = 'PENDING_DELETED',
  DELETED = 'DELETED',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED'
}

interface BasicGoalSubscriptionPaymentSessionModel {
  checkoutUrl: string;
}

interface BasicGoalSubscriptionModel {
  id: number;
  status: GoalSubscriptionStatus;
  priority: GoalSubscriptionPriority;
  checkoutSession?: BasicGoalSubscriptionPaymentSessionModel;
  strategyEndReached: boolean;
  progress?: GoalProgressModel;
  hasNewContent?: boolean;
}

enum GoalUsersFilter {
  ALL = 'ALL',
  NOT_STARTED = 'NOT_STARTED',
  BARELY_STARTED = 'BARELY_STARTED',
  HARD_MATERIAL = 'HARD_MATERIAL',
  BEST = 'BEST',
  ACCESS_GRANTED = 'ACCESS_GRANTED'
}

enum DisplayMode {
  EMBEDDED = 'embedded',
  STANDALONE = 'standalone'
}

enum PreviewType {
  DESKTOP = 'desktop',
  MOBILE = 'mobile',
  TABLET = 'tablet'
}

export {
  DisplayMode,
  Gender,
  GoalSubscriptionPriority,
  GoalSubscriptionStatus,
  GoalUsersFilter,
  PreviewType,
  Unit,
  UnitNamesIndex
};

export type {
  BasicGoalSubscriptionModel,
  BasicGoalSubscriptionPaymentSessionModel,
  SuccessCreatedEntity
};
